import { jsxs, jsx } from "react/jsx-runtime";
import * as React from "react";
import { cx } from "../internal/cx.js";
import { withVars } from "./styleVars.js";
const Kpi = React.forwardRef(function Kpi2({ label, value, unit, foot, color, className, style, ...rest }, ref) {
  const hasUnit = unit != null && unit !== false && unit !== "";
  const hasFoot = foot != null && foot !== false && foot !== "";
  return /* @__PURE__ */ jsxs("div", { ref, className: cx("ev-card", "ev-kpi", className), style: withVars(style, { "--ev-kpi-color": color }), ...rest, children: [
    /* @__PURE__ */ jsxs("div", { className: "ev-kpi__label", children: [
      color ? /* @__PURE__ */ jsx("i", { "aria-hidden": "true" }) : null,
      label
    ] }),
    /* @__PURE__ */ jsxs("div", { className: "ev-kpi__value", children: [
      value,
      hasUnit ? /* @__PURE__ */ jsx("small", { children: unit }) : null
    ] }),
    hasFoot ? /* @__PURE__ */ jsx("div", { className: "ev-kpi__foot", children: foot }) : null
  ] });
});
const KpiGrid = React.forwardRef(function KpiGrid2({ className, ...rest }, ref) {
  return /* @__PURE__ */ jsx("div", { ref, className: cx("ev-kpis", className), ...rest });
});
export {
  Kpi,
  KpiGrid
};
//# sourceMappingURL=Kpi.js.map
